import Splide from "@splidejs/splide";

function initSliderSpeakers(context) {
	const root = context && typeof context.querySelectorAll === "function" ? context : document;
	root.querySelectorAll(".splide-speackers").forEach((el) => {
		const splideSpeackers = new Splide(el, {
			perPage: 2,
			gap: "34px",
			pagination: true,
			arrows: true,
			drag: "free",
			snap: true,
			focus: "left",
			autoplay: false,
			focus: 0,
			speed: 700,
			omitEnd: true,
			breakpoints: {
				991: {
					perPage: 1.5,
					gap: "30px",
				},
				768: {
					perPage: 1,
					padding: { right: "17%", left: 0 },
					gap: "16px",
				},
			},
		});


		splideSpeackers.on("overflow", function (isOverflow) {
			splideSpeackers.options = {
				arrows: isOverflow,
				pagination: isOverflow,
				drag: isOverflow,
			};
		});

		splideSpeackers.mount();
	});
}

// Front-end
document.addEventListener("DOMContentLoaded", () => initSliderSpeakers());

// Gutenberg / ACF editor
if (window.acf) {
	window.acf.addAction("render_block_preview/type=bloc-speakers", ($block) => {
		initSliderSpeakers($block && $block.jquery ? $block.get(0) : $block);
	});
}
